import React, {ReactElement} from 'react';

import {homeGridItems, upcomingHomeItems} from '../../../lib/constants';
import {homeGridItemType} from '../../../lib/types';

const Grid = ({
  onGridItemClick,
}: {
  onGridItemClick: (item: homeGridItemType) => void;
}): ReactElement => {
  return (
    // To be uncommented in Phase 2

    <div className="grid gap-4 justify-between grid-cols-2 sm:grid-cols-4">
      {homeGridItems.map((item, index) => (
        <div
          key={index}
          className="h-26 w-full rounded-3xl bg-blue_zero p-2 cursor-pointer shadow-xl h-auto grid-item"
          onClick={() => onGridItemClick(item)}>
          <img
            className="ml-4 my-2.5 h-8 w-8 object-contain"
            src={item.icon}
            alt={`${item.text1} ${item.text2}`}
          />
          <div className=" ml-4 flex flex-col font-medium text-base  text-white">
            <p>{item.text1}</p>
            <p>{item.text2}</p>
          </div>
        </div>
      ))}
    </div>

    // To be Removed in Phase 2
    //     <div className="grid gap-4 justify-between grid-cols-1 sm:grid-cols-2">
    //         <div className="grid gap-4 justify-between grid-cols-2">
    //             {homeGridItems.map((item, index) => (
    //                 <div key={index} className="h-26 w-full rounded-3xl bg-blue_zero p-1.5 cursor-pointer shadow-xl h-auto grid-item" onClick={() => onGridItemClick(item)}>
    //                     <img className="ml-4 my-1.5 h-8 w-8 object-contain" src={item.icon} alt={`${item.text1} ${item.text2}`} />
    //                     <div className=" ml-4 flex flex-col font-medium text-base  text-white">
    //                         <p>{item.text1}</p>
    //                         <p>{item.text2}</p>
    //                     </div>
    //                 </div>
    //             ))}
    //         </div>
    //         <div className="grid gap-4 justify-between grid-cols-2 relative">
    //             <div className="inset-0 absolute flex justify-center items-center rounded-3xl bg-white bg-opacity-70 text-xl font-medium text-royal_blue">COMING SOON!</div>
    //             {upcomingHomeItems.map((item, index) => (
    //                 <div key={index} className="h-26 w-full rounded-3xl bg-blue_zero p-1.5 cursor-pointer shadow-xl h-auto grid-item" onClick={() => onGridItemClick(item)}>
    //                     <img className="ml-4 my-1.5 h-8 w-8 object-contain" src={item.icon} alt={`${item.text1} ${item.text2}`} />
    //                     <div className=" ml-4 flex flex-col font-medium text-base  text-white">
    //                         <p>{item.text1}</p>
    //                         <p>{item.text2}</p>
    //                     </div>
    //                 </div>
    //             ))}
    //         </div>
    //     </div>
  );
};

export default Grid;
